import {
  AdminsSelectDialogComponent,
  AdminsSelectDialogData,
} from '../dialogs/admins-select-dialog/admins-select-dialog.component';

export { AdminsSelectDialogComponent, AdminsSelectDialogData };
